export {
  isAdmin,
  isAuthor,
} from "lib-core"

